import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { JOBS_QUERIES, prefetchJobDetail } from "~/shared/api/jobs/jobs.queries";
import { getFilterParams } from "~/shared/components/FiltersV2/helpers/getFilterParams";
import { getTableParamsFromRequest } from "~/shared/util/tableHelpers";
import { getJobSearchParams } from "~/team/search-params/job.search-params";
import { ADD_PARTICIPANT_TABLE_KEY } from "~/team/views/JobParticipantGamePlansView/components/AddParticipants";
import { transformFiltersFromJob } from "~/team/views/JobParticipantGamePlansView/JobParticipantGamePlansView.helpers";

export function jobParticipantGamePlansViewLoader(queryClient: QueryClient, { params, request }: LoaderFunctionArgs) {
  try {
    const { jobId } = params ?? {};
    const searchParams = new URL(request.url).searchParams;

    if (!jobId) {
      throw new Error("Job ID is required to load game plans");
    }

    const { brainstormsTerm } = getJobSearchParams(searchParams);
    queryClient.ensureQueryData(JOBS_QUERIES.brainstormsList(jobId, { params: { term: brainstormsTerm } }));

    async function initJobPotentialParticipantsPromise(jobId: string) {
      const job = await prefetchJobDetail(jobId, queryClient);
      const filters = getFilterParams({
        key: ADD_PARTICIPANT_TABLE_KEY,
        searchParams,
        initialFilters: transformFiltersFromJob(job),
      });

      const params = getTableParamsFromRequest({
        key: ADD_PARTICIPANT_TABLE_KEY,
        request,
        filters,
      });

      return queryClient.ensureQueryData(JOBS_QUERIES.potentialParticipantsList(jobId, params));
    }
    initJobPotentialParticipantsPromise(jobId);

    return null;
  } catch (error) {
    return null;
  }
}
